module.exports = __webpack_public_path__ + "static/media/chopin-footer-4-pl.00214eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chopin-footer-4-pl.svg
// module id = 630
// module chunks = 0